__turbopack_context__.v({
  "animate-arrow-hover": "animations-module__bEDJYa__animate-arrow-hover",
  "arrow-hover": "animations-module__bEDJYa__arrow-hover",
  "arrow-up-right-icon": "animations-module__bEDJYa__arrow-up-right-icon",
  "popover-item": "animations-module__bEDJYa__popover-item",
});
